<template>
  <div class="overflow">
  	<div v-for="(item,ind) in list" :key="item.key" v-if="ind < 3">
      <template v-if="item.status == 0">
        <img :src="item.url" width="50" height="50" class="head_pic" @click="centerDialogVisible = true;imgList=listArr" />
        <p :title="item.txt">{{item.txt}}</p>
      </template>
  	</div>
    <div v-for="(item,ind) in list" style="display: block;width: auto;">
    	<a target="_blank"  v-if="item.status == 1"  :href="item.url" download="下载" class="el-icon-download a" :title="item.url">{{item.txt}}</a>
    </div>
  	<div v-if="listArr.length > 3" class="err"><img src="./../../assets/img/err.png"></div>
    <el-dialog class="dialog11" title="更多" :visible.sync="centerDialogVisible" center>
    	<template v-for="item in list">
    		<img class="imgList" :src="item.url" :key="item.key"/>
    	</template>
    </el-dialog>
  </div>
</template>

<script>
  export default{
    data(){
      return {
        list:[],
        centerDialogVisible:false
      }
    },
    props:{
      listArr:{
        type:Array,
        default:[]
      }
    },
    mounted() {
       var reg = /(.*)\.(jpg|gif|bmp|png)$/
      this.listArr.forEach((item1,index) => {
        if(reg.test(item1.url)){
          this.list.push({url:item1.url,txt:item1.txt,status:0,key:Math.random()})
        }else{
          this.list.push({url:item1.url,txt:item1.txt,status:1,key:Math.random()})
        }
      })
    }
  }
</script>

<style scoped="scoped">
  .overflow {
  	width: 198px;
  	text-align: left;
  	cursor: pointer;
  	overflow: hidden;
  	text-overflow: ellipsis;
  	white-space: nowrap
  }

  .overflow div {
  	margin-right: 10px;
  	width: 50px;
  	display: inline-block;
  	vertical-align: middle;
  }

  .overflow div p {
  	overflow: hidden;
  	text-overflow: ellipsis;
  	white-space: nowrap;
  }

  .overflow .err img {
  	height: 23px;
  	width: 13px;
  }
  .imgList {
  	width: 244px;
  	margin-right: 10px;
  	margin-bottom: 10px;
  	border-radius: 5px;
  }
  .dialog11{width: 100vw !important;}
.a{display: block;margin-top: 5px;}
</style>



// WEBPACK FOOTER //
// src/components/common/isJpg.vue